import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { ManagementApiService } from '../../../../../services';
import { CustomToastService } from '../../../../../services/custom-toast.service';
import { Compare } from '../../../../settings/core/Validators/compare.Validator';
import { MustValue } from '../../../../settings/core/Validators/mustValue.validator';
import { SettingValueModel, UserSettingModel } from '../../../../settings/models/informate';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { WarningDialogComponent } from 'src/app/shared/info-dialogs/warning-dialog/warning-dialog.component';
import { SuccessDialogComponent } from 'src/app/shared/info-dialogs/success-dialog/success-dialog.component';
import { ErrorDialogComponent } from 'src/app/shared/info-dialogs/error-dialog/error-dialog.component';
import { Subject } from 'rxjs';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { InstanceSettingModel } from 'src/app/Modules/settings/models/informate/instance-setting-model';

export interface ComponentGroupModel {
    index: number;
    checked: boolean;
    visible: ComponentControlModel;
    text: ComponentControlModel;
    value: ComponentControlModel;
}
export interface ComponentControlModel {
    key: string;
    name: string;
}
@Component({
    selector: 'app-calculation-percentage-settings',
    templateUrl: './calculation-percentage-settings.html',
    styleUrls: ['./calculation-percentage-settings.scss'],
    standalone: false
})
export class CalculationPercentageSettingsComponent implements OnInit {
    destroy$ = new Subject();
    passes: number[];
    passState: ComponentGroupModel[];
    isLeastSelected: boolean;
    userSettings: UserSettingModel[];
    instanceUserSettings: InstanceSettingModel[];
    public form: UntypedFormGroup;
    passCount: number = 4;
    lastSelectedPass: ComponentGroupModel;

    private _sectionPrefix = 'Calculation_Pass';
    private dataSource: any[];
    @Input() displayIDMSSettings: boolean;
    //@Input() userSettingsIDMS: UserSettingModel[];
    @Input() userSettingsIDMS: any[];
    profileSettingAreaId: string;
    userSettings2: InstanceSettingModel[];
    defaultUnitSettings: InstanceSettingModel[];
    calculationPreferenceSettings: InstanceSettingModel[];

    constructor(
        private fb: UntypedFormBuilder,
        private mgmtApi: ManagementApiService,
        private cd: ChangeDetectorRef,
        private ActiveModel: NgbActiveModal,
        private customToastService: CustomToastService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private user_utility: UserUtilityService,
        private modelService: NgbModal,
        private globalEmittersService: GlobalEmittersService
    ) {
        this.isLeastSelected = false;
    }

    ngOnInit(): void {
        if (this.displayIDMSSettings) {
            this.loadIDMSSettings();
        } else {
            this.getSettings();
        }
    }

    loadIDMSSettings(): void {
        this.mgmtApi.getSettingProfileAreaId('informate').subscribe((res) => {
            if (res.success === true) {
                this.profileSettingAreaId = res.response.settingAreaId;
                if (this.profileSettingAreaId) {
                    this.mgmtApi.getSettingbySettinfAreaIdForIdms(this.profileSettingAreaId).subscribe((userSettings) => {
                        if (userSettings.success === true) {
                            this.userSettings2 = userSettings.response;
                            this.instanceUserSettings = this.userSettings2;
                            this.buildForm();
                            this.defaultUnitSettings = this.getIDMSSectionData('Defaults', false);

                            this.calculationPreferenceSettings = this.getIDMSSectionData('Calculation Preferences', false);

                            this.dataSource = this.getIDMSSectionData('Calculation Preferences', false);

                            this.LoadControls();
                            this.cd.markForCheck();
                        } else {
                            this.user_utility.errorModelPopup(userSettings.message);
                        }
                    });
                }
            } else {
                this.user_utility.errorModelPopup(res.message);
            }
        });
    }

    getIDMSSectionData(sectionName: string, isSubSection: boolean = false): InstanceSettingModel[] {
        const sections: InstanceSettingModel[] = this.instanceUserSettings.filter((item: InstanceSettingModel) => {
            if (isSubSection) {
                return item.setting.settingSubSection?.name.toLowerCase() === sectionName.toLowerCase();
            }

            return item.setting.settingSubSection?.settingSection.name.toLowerCase() === sectionName.toLowerCase();
        });

        return sections;
    }

    getSectionData(sectionName: string, isSubSection: boolean = false): UserSettingModel[] {
        const sections: UserSettingModel[] = this.userSettings.filter((item: UserSettingModel) => {
            if (isSubSection) {
                return item.setting.settingSubSection?.name.toLowerCase() === sectionName.toLowerCase();
            }
            return item.setting.settingSubSection?.settingSection.name.toLowerCase() === sectionName.toLowerCase();
        });
        return sections;
    }

    getSettings(): void {
        this.ngxUiLoaderService.start();
        this.mgmtApi
            .getSettingProfileAreaId('informate')
            .pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
                if (res.success === true) {
                    let profileSettingAreaId = res.response.settingAreaId;
                    if (profileSettingAreaId) {
                        this.mgmtApi
                            .getSettingbySettinfAreaId(profileSettingAreaId)
                            .pipe(takeUntil(this.destroy$))
                            .subscribe((userSettings) => {
                                this.ngxUiLoaderService.stop();
                                if (userSettings.success === true) {
                                    this.userSettings = userSettings.response;
                                    this.buildForm();
                                    //this.defaultUnitSettings = this.getSectionData('Defaults', false)
                                    this.dataSource = this.getSectionData('Calculation Preferences', false);
                                    this.LoadControls();
                                    this.cd.markForCheck();
                                } else {
                                    // this.ngxUiLoaderService.stop();
                                    // this.cd.
                                    // this.user_utility.errorModelPopup(userSettings.message)
                                }
                            });
                    }
                } else {
                    this.ngxUiLoaderService.stop();
                    //  this.user_utility.errorModelPopup(res.message)
                }
            });
        this.cd.detectChanges();
    }

    buildForm(): void {
        this.form = null;
        this.form = this.fb.group({});

        if (this.userSettings2 && this.userSettings2.length > 0) {
            this.userSettings2.forEach((obj, index) => {
                const validatorsToAdd = [];
                if (obj.setting.isRequired) {
                    validatorsToAdd.push(Validators.required);
                }
                this.form.addControl(obj.setting.key, this.fb.control(this.getFormStateValue(obj), validatorsToAdd));
            });
        }

        if (this.userSettings && this.userSettings.length > 0) {
            this.userSettings.forEach((obj, index) => {
                const validatorsToAdd = [];
                if (obj.setting.isRequired) {
                    validatorsToAdd.push(Validators.required);
                }
                this.form.addControl(obj.setting.key, this.fb.control(this.getFormStateValue(obj), validatorsToAdd));
            });
        }

        this.form.valueChanges
            .pipe(debounceTime(100), distinctUntilChanged())
            .pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
                if (res) {
                    this.checkingValidators();
                }
            });
        this.cd.detectChanges();
    }

    getFormStateValue(userSetting: UserSettingModel | InstanceSettingModel) {
        if (userSetting.value) {
            return userSetting.value;
        }
        if (userSetting.settingValue) {
            return userSetting.settingValue.settingValueId;
        }
        return null;
    }

    LoadControls() {
        this.passes = Array(this.passCount)
            .fill(1)
            .map((x, i) => i + 1);
        this.passState = this.passes.map((pass, index): ComponentGroupModel => {
            return {
                index: pass,
                checked: this.getCheckedState(this.getControlData(pass, 'Visible').setting.key),
                visible: {
                    key: this.getControlData(pass, 'Visible').setting.key,
                    name: this.getControlData(pass, 'Visible').setting.name,
                },
                text: {
                    key: this.getControlData(pass, 'Text').setting.key,
                    name: this.getControlData(pass, 'Text').setting.name,
                },
                value: {
                    key: this.getControlData(pass, 'Value').setting.key,
                    name: this.getControlData(pass, 'Value').setting.name,
                },
            };
        });
        for (let x = 0; x < this.passState.length; x++) {
            if (this.passState[x].checked) {
                this.lastSelectedPass = this.passState[x];
            }
        }
        for (let x = 0; x < this.passState.length; x++) {
            if (this.passState[x].checked === true) {
                this.manageControls(this.passState[x], this.passState[x].checked);
            }
        }
        this.cd.markForCheck();
    }

    getControlData1(pass: number, type: string): InstanceSettingModel {
        return this.dataSource.find((item) => item.setting.key.toLowerCase() === `${this._sectionPrefix}${pass}_${type}`.toLowerCase()) ?? null;
    }

    getControlData(pass: number, type: string): UserSettingModel {
        return this.dataSource.find((item) => item.setting.key.toLowerCase() === `${this._sectionPrefix}${pass}_${type}`.toLowerCase()) ?? null;
    }

    getCheckedState(key: string): boolean {
        const ctrlModel: UserSettingModel = this.dataSource.find((item) => item.setting.key.toLowerCase() === key.toLowerCase()) ?? null;
        if (!ctrlModel) return false;
        return ctrlModel.settingValue?.value.toLowerCase() === 'true';
    }

    textBoxChange(pass: ComponentGroupModel, event): void {
        const ctrlModel: UserSettingModel = this.dataSource.find((item) => item.setting.key === event.target.name) ?? null;
        if (!ctrlModel) return;
        if (ctrlModel.value !== event.target.value) {
            this.form.get(ctrlModel.setting.key).markAsDirty();
            this.form.get(ctrlModel.setting.key).markAsTouched();
        } else {
            this.form.get(ctrlModel.setting.key).markAsPristine();
        }
        this.checkingValidators();
    }

    checkboxChange(pass: ComponentGroupModel, event: MatCheckboxChange | any): void {
        //  this.isFourthDisabled(pass);
        // if (event.checked && pass.value.key === 'Calculation_Pass4_Value') {
        //     const canEnableFourth = this.passState[0].checked && this.passState[1].checked && this.passState[2].checked;

        //     if (!canEnableFourth) {
        //         event.source.checked = false;
        //         return;
        //     }
        // }

        if (event.checked) {
            for (let x = 0; x < pass.index; x++) {
                if (pass.index === 4 && x < 3) {
                    continue;
                }
                const ctrlModel: UserSettingModel =
                    this.dataSource.find((item) => item.setting.key.toLowerCase() === this.passState[x].visible.key.toLowerCase()) ?? null;
                if (!ctrlModel) return;
                const selectedOption: SettingValueModel = ctrlModel.setting.settingValues.find(
                    (opt) => opt.value.toLowerCase() === String(event.checked).toLowerCase()
                );
                if (selectedOption) {
                    this.form.get(ctrlModel.setting.key).setValue(selectedOption.settingValueId);
                    if (ctrlModel.settingValue.settingValueId !== selectedOption.settingValueId) {
                        this.form.get(ctrlModel.setting.key).markAsDirty();
                        this.form.get(ctrlModel.setting.key).markAsTouched();
                    } else {
                        this.form.get(ctrlModel.setting.key).markAsPristine();
                    }
                }
            }
        } else {
            // checkbox is unchecked
            if (pass.index === 1) {
                this.isLeastSelected = true;
            }
            for (let x = pass.index - 1; x < (pass.index === 4 ? this.passState.length : this.passState.length - 1); x++) {
                const ctrlModel: UserSettingModel =
                    this.dataSource.find((item) => item.setting.key.toLowerCase() === this.passState[x].visible.key.toLowerCase()) ?? null;
                if (!ctrlModel) return;
                const selectedOption: SettingValueModel = ctrlModel.setting.settingValues.find(
                    (opt) => opt.value.toLowerCase() === String(event.checked).toLowerCase()
                );
                if (selectedOption) {
                    this.form.get(ctrlModel.setting.key).setValue(selectedOption.settingValueId);
                    if (ctrlModel.settingValue.settingValueId !== selectedOption.settingValueId) {
                        this.form.get(ctrlModel.setting.key).markAsDirty();
                        this.form.get(ctrlModel.setting.key).markAsTouched();
                    } else {
                        this.form.get(ctrlModel.setting.key).markAsPristine();
                    }
                }
            }
            this.removeValidators();
        }
        this.manageControls(pass, event.checked);
        this.toggleCheckBox(pass, event.checked);
        this.checkingValidators();

        this.user_utility.noneSelectedPassPct = !this.passState.some((x) => x.checked);
    }

    disableControl(i: number) {
        let ctrlModel = this.passState.find((item) => item.index === i);
        this.form.controls[ctrlModel.value.key].disable();
        this.form.controls[ctrlModel.text.key].disable();
    }

    enableControl(i: number) {
        let ctrlModel = this.passState.find((item) => item.index === i);
        this.form.controls[ctrlModel.value.key].enable();
        this.form.controls[ctrlModel.text.key].enable();
    }

    manageControls(pass: ComponentGroupModel, checked: boolean): Promise<any> {
        return new Promise<true>((resolve, reject) => {
            switch (pass.index) {
                case 1:
                    if (checked === true && pass.index === 1) {
                        pass.checked = checked;
                        this.enableControl(1);
                        this.enableControl(2);
                        this.disableControl(3);
                    } else {
                        this.enableControl(1);
                        this.disableControl(2);
                        this.disableControl(3);
                        this.disableControl(4);
                        let ctrlModel = this.passState.filter((item) => item.index === 2 || item.index === 3 || item.index === 4);
                        ctrlModel.forEach((x) => {
                            this.form.get(x.value.key).setValidators([Validators.max(100), Validators.min(1)]);
                            this.form.get(x.value.key).reset();
                        });
                    }
                    break;
                case 2:
                    if (checked === true && pass.index === 2) {
                        this.enableControl(1);
                        this.enableControl(2);
                        this.enableControl(3);
                    } else {
                        this.enableControl(1);
                        this.enableControl(2);
                        let ctrl = this.getControl(2);
                        this.form.get(ctrl.value.key).setValue(0);
                        this.form.get(ctrl.value.key).markAsDirty();
                        this.form.get(ctrl.value.key).markAsTouched();
                        this.disableControl(3);
                        let ctrlModel = this.passState.filter((item) => item.index === 3);
                        ctrlModel.forEach((x) => {
                            this.form.get(x.value.key).setValidators([Validators.max(100), Validators.min(1)]);
                            this.form.get(x.value.key).reset();
                        });
                    }
                    break;
                case 3:
                    if (checked === true && pass.index === 3) {
                        this.enableControl(1);
                        this.enableControl(2);
                        this.enableControl(3);
                    } else {
                        let ctrl = this.getControl(3);
                        this.form.get(ctrl.value.key).setValue(0);
                        this.form.get(ctrl.value.key).markAsDirty();
                        this.form.get(ctrl.value.key).markAsTouched();
                        this.enableControl(1);
                        this.enableControl(2);
                        this.enableControl(3);
                    }
                    break;

                case 4:
                    if (checked === true && pass.index === 4) {
                        this.enableControl(1);
                        this.enableControl(2);
                        this.enableControl(3);
                        this.enableControl(4);
                    }

                    break;
            }
        });
    }

    toggleCheckBox(pass: ComponentGroupModel, checked: boolean): Promise<true> {
        return new Promise<true>((resolve, reject) => {
            if (pass?.index < 5) {
                if (!checked && pass.index < this.passCount) {
                    for (var i = this.passCount + 1; i > pass.index; i--) {
                        this.toggleCheckBox(
                            this.passState.find((item) => item.index === i),
                            false
                        );
                    }
                }
                if (checked) {
                    for (var i = 1; i < this.passCount; i++) {
                        const passCheck = this.passState.find((item) => item.index === i);
                        if (!passCheck.checked && i < pass.index) {
                            this.toggleCheckBox(passCheck, true);
                        }
                    }
                }
                pass.checked = checked;
            }
        });
    }

    checkingValidators() {
        let lastIndex = this.lastIndex();
        switch (lastIndex) {
            case 1:
                let ctrlModel = this.getControl(1);
                this.form.get(ctrlModel.value.key).setValidators(Validators.required);
                this.form.get(ctrlModel.value.key).updateValueAndValidity();
                if (this.form.get(ctrlModel.value.key).value != null) {
                    if (this.form.get(ctrlModel.value.key).value <= 0) {
                        this.form.get(ctrlModel.value.key).setValidators(Validators.compose([MustValue]));
                        this.form.get(ctrlModel.value.key).updateValueAndValidity();
                    } else {
                        this.form.get(ctrlModel.value.key).setValidators(Validators.compose([Validators.max(100), Validators.min(100)]));
                        this.form.get(ctrlModel.value.key).updateValueAndValidity();
                    }
                }
                this.cd.markForCheck();
                break;
            case 2:
                let ctrlModel2 = this.getControl(2);
                let ctrlModel1 = this.getControl(1);
                let formControl1 = this.form.get(ctrlModel1.value.key);
                let formControl2 = this.form.get(ctrlModel2.value.key);
                this.form.get(ctrlModel1.value.key).clearValidators();
                this.form.get(ctrlModel1.value.key).setValidators([Validators.required, MustValue]);
                this.form.get(ctrlModel1.value.key).updateValueAndValidity();
                this.form.get(ctrlModel2.value.key).setValidators(Validators.required);
                this.form.get(ctrlModel2.value.key).updateValueAndValidity();
                if (formControl2.value != null) {
                    if (formControl2.value <= 0) {
                        this.form.get(ctrlModel2.value.key).setValidators([MustValue]);
                        this.form.get(ctrlModel2.value.key).updateValueAndValidity();
                    } else {
                        this.form.get(ctrlModel2.value.key).clearValidators();
                        this.form
                            .get(ctrlModel2.value.key)
                            .setValidators(
                                Validators.compose([
                                    Validators.required,
                                    Validators.max(100),
                                    Validators.min(100),
                                    MustValue,
                                    Compare(formControl1, formControl2),
                                ])
                            );
                        this.form.get(ctrlModel2.value.key).updateValueAndValidity();
                    }
                }
                break;
            case 3:
                let ctrl1 = this.getControl(1);
                let ctrl2 = this.getControl(2);
                let ctrl3 = this.getControl(3);
                let formControls1 = this.form.get(ctrl1.value.key);
                let formControls2 = this.form.get(ctrl2.value.key);
                let formControls3 = this.form.get(ctrl3.value.key);
                this.form.get(ctrl1.value.key).clearValidators();
                this.form.get(ctrl2.value.key).clearValidators();
                this.form.get(ctrl1.value.key).setValidators([Validators.required, MustValue]);
                this.form.get(ctrl1.value.key).updateValueAndValidity();
                this.form.get(ctrl2.value.key).setValidators([Validators.required, MustValue]);
                this.form.get(ctrl2.value.key).updateValueAndValidity();
                this.form.get(ctrl3.value.key).setValidators(Validators.required);
                this.form.get(ctrl3.value.key).updateValueAndValidity();
                if (formControls2.value != null) {
                    this.form.get(ctrl2.value.key).clearValidators();
                    formControls2.setValidators(Validators.compose([Validators.required, MustValue, Compare(formControls1, formControls2)]));
                }
                if (formControls3.value != null) {
                    if (formControls3.value <= 0) {
                        this.form.get(ctrl3.value.key).setValidators([MustValue]);
                        this.form.get(ctrl3.value.key).updateValueAndValidity();
                    } else {
                        this.form
                            .get(ctrl3.value.key)
                            .setValidators(Validators.compose([Validators.min(100), Validators.max(100), Compare(formControls2, formControls3)]));
                        this.form.get(ctrl3.value.key).updateValueAndValidity();
                    }
                }
                break;
        }
        this.form.updateValueAndValidity();
        this.cd.detectChanges();
    }

    lastIndex() {
        let index1 = -1;
        for (let i = 0; i < this.passState.length - 1; i++) {
            if (this.passState[i].checked === true) {
                index1 = this.passState[i].index;
            }
        }
        return index1;
    }

    removeValidators() {
        let ctrl1 = this.passState.find((item) => item.index === 1);
        let ctrl2 = this.passState.find((item) => item.index === 2);
        let ctrl3 = this.passState.find((item) => item.index === 3);
        this.form.get(ctrl1.value.key).clearValidators();
        this.form.get(ctrl2.value.key).clearValidators();
        this.form.get(ctrl3.value.key).clearValidators();
        this.form.updateValueAndValidity();
        this.cd.markForCheck();
    }

    getControl(i) {
        return this.passState.find((item) => item.checked === true && item.index === i);
    }

    closeModal() {
        this.ActiveModel.close();
    }

    async Save() {
        // informate form...
        if (this.user_utility.noneSelectedPassPct) {
            this.customToastService.infoToast('Atleast one pass must be selected!', 'Info');
            this.form.markAsDirty();
            this.form.markAsTouched();
            this.form.updateValueAndValidity();

            return;
        }

        if (this.form) {
            const updateJson = [];
            Object.keys(this.form.controls).forEach((key) => {
                const ctrl: AbstractControl = this.form.controls[key];
                const json = {};
                if (ctrl.dirty && ctrl.valid) {
                    if (!this.displayIDMSSettings) {
                        const userSetting: any = this.userSettings.find((item) => item.setting.key === key);
                        json['userSettingId'] = userSetting.userSettingId;
                        json['userId'] = userSetting.userId;
                        json['settingId'] = userSetting.setting.settingId;
                        if (userSetting?.settingValue) {
                            json['settingValueId'] = ctrl.value; //userSetting.settingValue.settingValueId
                        } else if (userSetting.value) {
                            json['value'] = ctrl.value; //userSetting.value
                        }
                        updateJson.push(json);
                    } else if (this.displayIDMSSettings) {
                        const userSetting: any = this.userSettings2.find((item) => item.setting.key === key);
                        json['instanceId'] = userSetting.instanceId;
                        json['settingId'] = userSetting.setting.settingId;
                        json['instanceSettingId'] = userSetting.instanceSettingId;
                        json['value'] = ctrl.value;
                        updateJson.push(json);
                    }
                }
            });
            // update mgmt service!
            if (updateJson.length !== 0 && this.displayIDMSSettings) {
                await this.updateSettingsIDMS(updateJson);
            } else if (updateJson.length !== 0) {
                await this.updateSettingsInformate(updateJson);
            }
        }
    }

    async updateSettingsInformate(updateJson) {
        await this.mgmtApi.updateUserSettings(updateJson).subscribe((result) => {
            if (result.success === true) {
                // let dialogRef = this.modelService.open(SuccessDialogComponent);
                // dialogRef.componentInstance.message = 'User settings updated!Please select the tool to see the updated Data';
                // this.customToastService.successToast('User settings updated!Please select the tool to see the updated Data', 'Success');
                this.mgmtApi.refreshUserDefaults();
                this.ActiveModel.close(true);
            } else {
                let dialogRef = this.modelService.open(ErrorDialogComponent);
                dialogRef.componentInstance.message = result.message;
                //this.customToastService.errorToast('Unable to update settings...', 'Failure');
            }
        });
    }

    async updateSettingsIDMS(updateJson) {
        await this.mgmtApi.updateInstanceSettings(updateJson).subscribe((result) => {
            if (result.success === true) {
                this.customToastService.successToast('Pass percentage settings saved successfully.', 'Success');
                this.globalEmittersService.isIdmsPreferenceSettingUpdated.next(true);
                this.ActiveModel.close(true);
            } else {
                let dialogRef = this.modelService.open(ErrorDialogComponent);
                dialogRef.componentInstance.message = result.message;
            }
        });
    }

    saveDisabled(): boolean {
        return this.informateFormState();
    }

    informateFormState(): boolean {
        if (!this.form) return true;
        return !(this.form.valid && this.form.dirty);
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
